import drawInfo from "./drawInfo";
import spetum from "./spetum";
import boarspear from "./boarspear"

const drawLuccaSpetumInfo = {
    shapes: [...drawInfo.shapes, ...spetum]
}

export default drawLuccaSpetumInfo;
